'use client';

import { type Content } from '@radix-ui/react-dialog';
import React, { useState } from 'react';
import { BASE_PATH } from '@/constants/constants';
import { ModalContent, ModalRoot, ModalTrigger } from '@/components/Modal/BaseModal';
import '../Modal.scss';

interface NavbarModalProps {
	children: React.ReactNode;
	hideModalTrigger?: boolean;
	modalTriggerAsChild?: boolean;
	open?: boolean;
	onInteractOutside?: React.ComponentPropsWithoutRef<typeof Content>['onInteractOutside'];
	size?: 'xs' | 'sm' | 'md' | 'lg';
}

export const NavbarMenuModal = (props: NavbarModalProps) => {
	const { children, hideModalTrigger = false, modalTriggerAsChild, open, onInteractOutside, size = 'md' } = props;

	const [menuIcon, setMenuIcon] = useState('menu');

	const onMenuOpenChange = () => {
		setMenuIcon(menuIcon === 'menu' ? 'close' : 'menu');
	};

	return (
		<div className="nav:d-none">
			<ModalRoot modal={true} open={open} onOpenChange={onMenuOpenChange}>
				{!hideModalTrigger && (
					<ModalTrigger asChild={modalTriggerAsChild}>
						<button type="button" className="navbar__menu-button">
							<svg className="control-button__icon icon" width="1em" height="1em" fill="currentColor">
								<use xlinkHref={`${BASE_PATH}/speedboat/icons/toyota-icons.svg#${menuIcon}`} />
							</svg>
						</button>
					</ModalTrigger>
				)}
				<ModalContent className="[ modal ]" data-size={size} data-variant="navbar" onInteractOutside={onInteractOutside}>
					<div className="[ modal__content ] [ position-relative p-md nav:d-none ]">
						<div>{children}</div>
					</div>
				</ModalContent>
			</ModalRoot>
		</div>
	);
};
